export default __webpack_public_path__ + "static/media/greeting24.0a9a5623.png";